<mat-toolbar class="toolbar" role="navigation">
    <a routerLink="/" aria-label="Homepage" i18n-aria-label="@@toolbar-link-homepage">
        <img class="toolbar__logo" alt="Scope Logo" src="assets/logo_scope_glyph.svg" />
    </a>

    <span
        *ngIf="checkEnvironment !== 'production'"
        class="riege-badge"
        [class.badge--grey]="checkEnvironment === 'local' || checkEnvironment === 'dev'"
        [class.badge--secondary]="checkEnvironment === 'staging'"
        selected
        >{{ checkEnvironment }}</span
    >

    <!-- nav: mobile-->
    <ul
        class="toolbar__menu"
        *ngIf="isMobile() && (showUnLocodes || showCommunityMap ||showScopeCommunity || showUserAdmin)">
        <li>
            <a
                mat-a
                [matMenuTriggerFor]="mobileMenu"
                class="toolbar__burger-menu"
                aria-haspopup="true"
                [attr.aria-expanded]="mobileMenu.closed"
                aria-label="Main menu"
                i18n-aria-label="@@menu-main">
                <mat-icon class="riege-icon">menu</mat-icon>
            </a>
        </li>
        <mat-menu #mobileMenu="matMenu" class="riege-menu">
            <li *ngIf="showUnLocodes">
                <a
                    mat-menu-item
                    i18n="@@menu-item-unlocodes"
                    data-testid="btn-toolbar-unlocodes"
                    routerLink="/unlocodes"
                    >UN/LOCODEs</a
                >
            </li>
            <li *ngIf="showCommunityMap && !showScopeCommunity">
                <a
                    routerLink="/community-map"
                    mat-menu-item
                    [routerLinkActive]="'active'"
                    data-testid="btn-toolbar-community-map"
                    i18n="@@menu-item-community-map"
                    >Community Map</a
                >
            </li>
            <li *ngIf="showScopeCommunity">
                <a
                    routerLink="/scope-community"
                    mat-menu-item
                    class="toolbar__menu-link"
                    [routerLinkActive]="'active'"
                    data-testid="btn-toolbar-scope-community"
                    i18n="@@menu-item-scope-community"
                    >Scope Community</a
                >
            </li>
            <li *ngIf="showUserAdmin && (authService.isAdmin() || authService.isSuperAdmin())">
                <a mat-menu-item i18n="@@menu-item-scopeusers" [routerLink]="'/administration/users'">Users</a>
            </li>
            <li *ngIf="showStyleGuide">
                <a
                    routerLink="/styleguide"
                    mat-menu-item
                    [routerLinkActive]="'active'"
                    color="primary"
                    class="toolbar__menu-link"
                    aria-label="Styleguide Button"
                    i18n-aria-label="@@button-label-styleguide"
                    >Styleguide</a
                >
            </li>
        </mat-menu>
    </ul>
    <!-- nav: not mobile-->
    <ul
        class="toolbar__menu"
        *ngIf="!isMobile() && (showUnLocodes || showCommunityMap || showScopeCommunity || showUserAdmin)">
        <li *ngIf="showUnLocodes">
            <a
                routerLink="/unlocodes"
                mat-button
                class="toolbar__menu-link"
                [routerLinkActive]="'active'"
                data-testid="btn-toolbar-unlocodes"
                i18n="@@menu-item-unlocodes"
                >UN/LOCODEs</a
            >
        </li>
        <li *ngIf="showCommunityMap && !showScopeCommunity">
            <a
                routerLink="/community-map"
                mat-button
                class="toolbar__menu-link"
                [routerLinkActive]="'active'"
                data-testid="btn-toolbar-community-map"
                i18n="@@menu-item-community-map"
                >Community Map</a
            >
        </li>
        <li *ngIf="showScopeCommunity">
            <a
                routerLink="/scope-community"
                mat-button
                class="toolbar__menu-link"
                [routerLinkActive]="'active'"
                data-testid="btn-toolbar-scope-community"
                i18n="@@menu-item-scope-community"
                >Scope Community</a
            >
        </li>
        <li *ngIf="showUserAdmin && (authService.isAdmin() || authService.isSuperAdmin())">
            <a
                routerLink="/administration/users"
                mat-button
                class="toolbar__menu-link"
                [routerLinkActive]="'active'"
                i18n="@@menu-item-scopeusers"
                >Users</a
            >
        </li>
        <li *ngIf="showStyleGuide">
            <a
                routerLink="/styleguide"
                mat-flat-button
                color="primary"
                class="toolbar__menu-link"
                aria-label="Styleguide Button"
                i18n-aria-label="@@button-label-styleguide"
                >Styleguide</a
            >
        </li>
    </ul>

    <!-- spacer -->
    <span class="toolbar__spacer"></span>

    <button
        mat-icon-button
        class="riege-button riege-button--icon"
        (onMenuOpen)="getStatus()"
        [matMenuTriggerFor]="helpMenu"
        aria-label="Help menu"
        i18n-aria-label="@@menu-help"
        aria-haspopup="true"
        [attr.aria-expanded]="helpMenu.closed"
        data-testid="toolbar-button-help">
        <mat-icon class="riege-icon">help_outline</mat-icon>
    </button>

    <mat-menu #helpMenu="matMenu" xPosition="before" class="riege-menu">
        <a mat-menu-item href="https://status.riege.com/" target="_blank">
            <span i18n="@@menu-item-status-page">System status</span>
            <span class="toolbar__status-indicator">
                <mat-icon *ngIf="indicator" class="riege-icon" [ngClass]="[color(), 'md-20']"
                    >{{ indicator() }}</mat-icon
                >
                <span class="cdk-visually-hidden">{{ status() }}</span>
            </span>
        </a>
        <a mat-menu-item href="{{ linkKnowledgeBase }}" target="_blank" i18n="@@menu-item-manual-link"
            >Knowledge base</a
        >
        <a
            mat-menu-item
            *ngIf="authService.isLoggedIn()"
            href="mailto:service@riege.com"
            i18n="@@menu-item-support-link">
            Contact support
        </a>
    </mat-menu>

    <ng-container *ngIf="!authService.isLoggedIn()">
        <button
            mat-flat-button
            color="primary"
            id="login"
            data-testid="toolbar-button-login"
            class="riege-button toolbar__button"
            [disabled]="authService.loginDisabled()"
            debounceClick
            (doClick)="login()"
            [debounceTime]="700"
            i18n="@@button-label-login"
            >Log in</button
        >
    </ng-container>

    <ng-container *ngIf="authService.isLoggedIn()">
        <button
            mat-icon-button
            class="riege-button riege-button--icon toolbar__button is-logged-in"
            [matMenuTriggerFor]="profileMenu"
            #menuTriggerProfile="matMenuTrigger"
            aria-label="User menu"
            i18n-aria-label="@@menu-user"
            aria-haspopup="true"
            [attr.aria-expanded]="profileMenu.closed"
            data-testid="toolbar-menu">
            <span class="toolbar__avatar">
                <mat-icon
                    class="riege-icon {{ currentUser().avatarURL }}"
                    svgIcon="{{ currentUser().avatarURL || 'avatar_placeholder' }}"
                    aria-hidden="true"></mat-icon>
            </span>
        </button>

        <mat-menu #profileMenu="matMenu" xPosition="before" class="riege-menu">
            <div class="riege-button profile not-dimmed" mat-menu-item disabled>
                <mat-icon
                    class="riege-icon {{ currentUser().avatarURL }}"
                    svgIcon="{{ currentUser().avatarURL || 'avatar_placeholder' }}"
                    aria-hidden="true"></mat-icon>
                <span class="profile__user-name">{{ currentUser().name }}</span><br />
                <span class="organization-name__helper-text">{{ organization() }}</span>
            </div>

            <mat-divider class="reset-margin--all"></mat-divider>

            <a
                mat-menu-item
                routerLink="/profile"
                i18n="@@toolbar-menu-profile-link"
                routerLinkActive="active"
                #rla="routerLinkActive"
                ariaCurrentWhenActive="page"
                data-testid="btn-user-profile"
                >Open user profile</a
            >

            <ng-container *ngIf="switchTenants">
                <button
                    mat-menu-item
                    class="not-dimmed"
                    [matMenuTriggerFor]="workspaceMenu"
                    data-testid="btn-switch-workspace"
                    aria-haspopup="true"
                    [attr.aria-expanded]="workspaceMenu.closed"
                    i18n="@@topbar-menu-switch-workspace"
                    >Switch workspace</button
                >

                <mat-menu #workspaceMenu="matMenu" xPosition="before" class="riege-menu">
                    <button mat-menu-item (click)="switchTenant('tenant')" data-testid="btn-organization"
                        >{{ organization() }}</button
                    >
                </mat-menu>
            </ng-container>

            <ng-container *ngIf="showOrganization && (authService.isAdmin() || authService.isSuperAdmin())">
                <a
                    mat-menu-item
                    [routerLink]="['/', 'organization', currentUser().organization!.scopeCode]"
                    i18n="@@toolbar-menu-manage-organization"
                    routerLinkActive="active"
                    #rla="routerLinkActive"
                    ariaCurrentWhenActive="page"
                    data-testid="btn-manage-organization"
                    >Manage organization</a
                >

                <mat-divider class="reset-margin--all"></mat-divider>
            </ng-container>

            <a mat-menu-item href="{{ envLink}}" target="_blank">{{ envText }}</a>

            <mat-divider class="reset-margin--all"></mat-divider>

            <a mat-menu-item id="logout" (click)="logout()" (keyup.enter)="logout()" i18n="@@topbar-menu-logout-link"
                >Log out</a
            >
        </mat-menu>
    </ng-container>
</mat-toolbar>
